export default __webpack_public_path__ + "static/media/icon_mesh_on.19d14e3b.svg";